import React from 'react';
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { FORM_COLORS, FORM_STEPS } from '../constants';

const useStyles = makeStyles(() => ({
  bar: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 22,
    padding: '0 4px',
  },
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 5,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
  },
  circle: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    border: `1.5px solid ${FORM_COLORS.border}`,
    background: FORM_COLORS.bg,
    color: FORM_COLORS.textSecondary,
    transition: 'all .2s',
  },
  circleDone: {
    background: FORM_COLORS.pink,
    color: '#fff',
    borderColor: FORM_COLORS.pink,
  },
  circleActive: {
    background: FORM_COLORS.pinkLight,
    color: FORM_COLORS.pink,
    borderColor: FORM_COLORS.pink,
  },
  stepLabel: {
    fontSize: 11,
    color: FORM_COLORS.textSecondary,
    whiteSpace: 'nowrap',
  },
  stepLabelActive: {
    color: FORM_COLORS.pink,
  },
  line: {
    flex: 1,
    height: 2,
    background: FORM_COLORS.border,
    margin: '0 6px 22px',
    transition: 'background .2s',
  },
  lineDone: {
    background: FORM_COLORS.pink,
  },
}));

interface FormStepperProps {
  currentStep: number;
  onStepClick: (step: number) => void;
}

export const FormStepper = ({ currentStep, onStepClick }: FormStepperProps) => {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      {FORM_STEPS.map((label, index) => {
        const isDone = index < currentStep;
        const isActive = index === currentStep;
        return (
          <React.Fragment key={label}>
            <button
              type="button"
              className={classes.step}
              onClick={() => onStepClick(index)}
            >
              <div
                className={`${classes.circle} ${isDone ? classes.circleDone : ''} ${
                  isActive ? classes.circleActive : ''
                }`}
              >
                {isDone ? <CheckIcon style={{ fontSize: 14 }} /> : index + 1}
              </div>
              <span
                className={`${classes.stepLabel} ${isActive ? classes.stepLabelActive : ''}`}
              >
                {label}
              </span>
            </button>
            {index < FORM_STEPS.length - 1 && (
              <div className={`${classes.line} ${isDone ? classes.lineDone : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
